import actions from '@/store/modules/auth/actions';
import mutations from '@/store/modules/auth/mutations';
import Auth from '@/store/modules/auth/constants';
import RolesHelper from '@/helpers/rolesHelper';

const state = {
  loading: false,
  isAuthorized: localStorage.getItem('user-isAuthorized') || false,
  userInfo: JSON.parse(localStorage.getItem('user-info')) || {},
};

// getters
const getters = {
  [Auth.getterTypes.userNameFirstLetter](localState) {
    if (!localState.userInfo.name) {
      return '';
    }

    return localState.userInfo.name.charAt(0);
  },
  [Auth.getterTypes.mainRole](localState) {
    return RolesHelper.getMainRole(localState.userInfo.roles || []);
  },
  [Auth.getterTypes.printingLabelPermission](localState) {
    return localState.userInfo.permissions.includes('printingLabel');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
